import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=2a17022e&"
import script from "./ModalComment.vue?vue&type=script&lang=js&"
export * from "./ModalComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports